import React from "react";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";

@observer
export default class Timer extends React.Component {
    timerInteval = null;

    finishTime = Date.parse('2020-06-10T00:00:00');
    @observable time = '';
    @observable isFinished = false;

    recalculateTime = () => {
        const now = Date.now();

        let diffSec = Math.round((this.finishTime - now) / 1000);
        if (diffSec < 0) {
            this.isFinished = true;
        } else {
            const sec = (diffSec % 60).toString().padStart(2, '0');
            diffSec = Math.floor(diffSec / 60);
            const min = (diffSec % 60).toString().padStart(2, '0');;
            diffSec = Math.floor(diffSec / 60);
            const hours = diffSec % 24;
            diffSec = Math.floor(diffSec / 24);

            this.time = diffSec + (diffSec == 1 ? " dzień " : " dni ") + hours + " godz " + min + " min " + sec + " s";
        }

    }

    componentWillUnmount() {
        clearInterval(this.timerInteval);
    }

    componentDidMount() {
        if (this.props.finishTime) {
            this.finishTime = Date.parse(this.props.finishTime.replace(/\s/, 'T'));
        }

        this.timerInteval = setInterval(() => this.recalculateTime(), 1000);
        this.recalculateTime();
    }

    componentDidUpdate(prevProps, _prevState) {
        if (this.props.finishTime !== prevProps.finishTime) {
            this.finishTime = Date.parse(this.props.finishTime);
            this.isFinished = false;
            this.recalculateTime();
        }
    }

    render() {
        return <React.Fragment>{!!this.isFinished ? "Zakończone" : this.time}</React.Fragment>
    }
}
